import * as React from 'react';
import SvgIcon from '../../SvgIcon';
const SvgCross = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M22.54.23a.81.81 0 0 0-1.13 0L12 9.64 2.59.23a.81.81 0 0 0-1.13 0C1.09.61.6 1.09.23 1.46a.8.8 0 0 0 0 1.13L9.64 12 .23 21.41a.8.8 0 0 0 0 1.13l1.23 1.23a.81.81 0 0 0 1.13 0L12 14.36l9.41 9.41a.81.81 0 0 0 1.13 0l1.23-1.23a.8.8 0 0 0 0-1.13L14.36 12l9.41-9.41a.8.8 0 0 0 0-1.13Z"
    }));
export default SvgCross;
